

function PreLoader(prop) {
    const show = prop.Loader === true || prop.isFallback === true;
    if (!show) return null;

    return (
        <div id="preloader">
            <div className="clear-loading loading-effect">
                <img src="/images/preloader.png" alt="home-logo" />
                <div className="spinner" />
            </div>
        </div>
    );
}

export default PreLoader;